// extracted by mini-css-extract-plugin
export default {"Instructions":"instructions_Instructions__8npUJ","appear":"instructions_appear__H8xIl","Button":"instructions_Button__eSkW-"};